export const LOCALE_KEY = 'localeLanguage'
export const AVAILABLE_LOCALES = ['zh-tw', 'zh-cn', 'en', 'ja' , 'ko']
export const LOCALE_MAP_2B = {
  'en':'en_US',
  'zh-tw':'zh_TW',
  'zh-cn':'zh_CN',
  'ja':'ja_JP',
  'ko':'ko_KR'
}
